import {useId,View,useZoomGesture,isTouchDevice} from "vritra";
import css from "./ZoomExample.module.css";
import {image0} from "Assets";


export default function ZoomExample(props){
    const {parent,id=useId("zoomexample")}=props;
    const zoomexample=View({parent,id,className:css.zoomexample});

    zoomexample.innateHTML=`
        ${isTouchDevice()?`
            <img class="${css.image}" src="${image0}"/>`:`
            <p class="${css.message}">Please use a touch device to see the preview</p>
        `}
    `;

    const imgEl=zoomexample.querySelector(`.${css.image}`);
    imgEl&&useZoomGesture({
        element:imgEl,
        maxScale:2,
        onZoomStart:(event)=>{
            event.preventDefault();
        },
    });

    return zoomexample;
}
